var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDispatch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 16C29.4183 16 33 12.4183 33 8C33 3.58172 29.4183 0 25 0C20.5817 0 17 3.58172 17 8C17 12.4183 20.5817 16 25 16ZM23.4274 11.6727L29.2422 5.85787C29.2942 5.80637 29.3234 5.73626 29.3234 5.66313C29.3234 5.58999 29.2942 5.51989 29.2422 5.46839L28.8582 5.0789C28.7497 4.9737 28.5773 4.9737 28.4688 5.0789L23.2299 10.3177L20.8546 7.94244C20.8031 7.89051 20.733 7.8613 20.6599 7.8613C20.5867 7.8613 20.5166 7.89051 20.4651 7.94244L20.0811 8.32644C20.0292 8.37794 20 8.44804 20 8.52118C20 8.59431 20.0292 8.66442 20.0811 8.71592L23.0379 11.6727C23.0894 11.7246 23.1595 11.7538 23.2327 11.7538C23.3058 11.7538 23.3759 11.7246 23.4274 11.6727Z",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.24 32H46C47.1045 32 48 32.8955 48 34V40.76C48.0053 41.5203 47.579 42.2179 46.9 42.56L45.68 43.16C44.5761 43.7168 43.3563 44.0046 42.12 44H42C42 46.2091 40.2091 48 38 48C35.7909 48 34 46.2091 34 44H12.0001C12.0001 46.2091 10.2092 48 8.00011 48C5.79098 48 4.00012 46.2091 4.00012 44H2.00013C0.895563 44 0.000135845 43.1046 0.000135845 42V37.6C-0.0122891 35.5519 1.52439 33.8253 3.56012 33.6L12.3801 32.24C13.4148 32.0864 14.3481 31.5336 14.9801 30.7L18.8001 25.6001C19.5555 24.5928 20.741 24.0001 22.0001 24.0001H33.52C35.0379 24.0009 36.4246 24.8607 37.1 26.2201L39.44 30.9C39.7821 31.579 40.4797 32.0053 41.24 32ZM22.0001 28.0002L19.0001 32.0002H35.5201L33.5201 28.0002H22.0001Z",
    fillOpacity: 0.7
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDispatch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Dispatch.fd425b2c.svg";
export { ForwardRef as ReactComponent };